<template>
  <div class="c-numbers">
    <div class="c-number" v-for="(n, key) in Numbers" v-bind:key="key">
      <img v-if="n!=='*'" :src="img(n)">
    </div>
  </div>
</template>
<script>
export default {
  name: 'ShowSuccessResult',
  props: {
    resultNumbers: {
      type: String,
      default: null
    }
  },
  computed: {
    Numbers() {
      if(this.resultNumbers) {
        return this.resultNumbers.split('')
      }else{
        return ['n', 'n', 'n', 'n', 'n']
      }
    }
  },
  methods: {
    img(number) {
      return require(`@/assets/theme/numbers/${number}.png`)
    }
  }
}
</script>
